import React from 'react';
import { connect } from 'react-redux';
import { startLogout, deleteAccount } from '../actions/auth';
import ConfirmDeleteAccountModal from './ConfirmDeleteAccountModal';
import { Link } from "react-router-dom"; 
export class Profile extends React.Component {
  state = {
    confirmDeleteAccountModalVisible: false
  };

  onLogout = () => {
    this.props.startLogout();
  };

  onDelete = () => {
    this.props.deleteAccount();
  };

  showConfirmDeleteAccountModal = (e) => {
    this.setState(() => ({ confirmDeleteAccountModalVisible: true }))
  };

  hideConfirmDeleteAccounteModal = (e) => {
    this.setState(() => ({ confirmDeleteAccountModalVisible: false }))
  };

  render() {
    return (
      <div>
        <div className="page-header profile">
        <div className="content-container">
            <h1 className="page_name">Manage Profile</h1> 
        </div>
    </div>
        <div className="content-container">
          <div>
            <p className="profile_avatar"><img className="avatar" src={ this.props.currentUser.photoURL || "/images/default_avatar.png" }/></p>
            <div className="profile_info">
              <h3 className="profile_name">Name:<br></br><span className='profile-data'>{ this.props.currentUser.displayName }</span></h3>
              <h3 className="profile_email">Email:<br></br><span className='profile-data'>{ this.props.currentUser.email }</span><img title="Email Verified" className={ this.props.currentUser.emailVerified ? 'isVerified' : 'isNotVerified' } src="/images/verified.png" /></h3>
            </div>
            <div className="block_div">
              <button className="button button--deleteAccount" onClick={ this.showConfirmDeleteAccountModal }>Delete My Account</button>
              <Link className="button return_home" to="/dashboard">Return Home</Link>
            </div>
          </div>
        </div>
        <ConfirmDeleteAccountModal 
          visible = { this.state.confirmDeleteAccountModalVisible }
          deleteAccount = { this.onDelete }
          hideModal = { this.hideConfirmDeleteAccounteModal }
        />   
      </div>
    )
  }      
};
 
const mapStateToProps = (state) => ({
  currentUser: state.auth.currentUser,
});
 
const mapDispatchToProps = (dispatch) => ({
    startLogout: () => dispatch(startLogout()),
    deleteAccount: () => dispatch(deleteAccount())
});
 
export default connect(mapStateToProps, mapDispatchToProps)(Profile);


// WEBPACK FOOTER //
// ./src/components/ProfilePage.js